import * as Styled from './colour-picker.style';
import { COLOURS } from './colour.constants';
import { ColourTokenButton } from 'approot/shared/colour/colour-token';

type Props = {
  currentColour: string;
  onSelectColour: (colour: string) => void;
};

const ColourPicker = ({ currentColour, onSelectColour }: Props) => (
  <Styled.ColourPickerPanelInner>
    {COLOURS.map(colour => (
      <ColourTokenButton
        key={colour.base}
        colours={colour}
        size={32}
        data-selector={`colour-${colour.name}`}
        isActive={currentColour === colour.base}
        onClick={() => onSelectColour(colour.base)}
      />
    ))}
  </Styled.ColourPickerPanelInner>
);

export default ColourPicker;
